// frontend/src/utils/form/validation.js
import { RULE_FIELD_MAP } from '../formConfig';

export function validateForm({ formData, rules }) {
  const errors = {};
  if (!rules) return errors;

  // 🔹 Flatten grouped rules (common, mountain, etc.)
  const flatRules = {};
  // console.log("VALIDATION RULES: ",rules);
  Object.values(rules).forEach(group => {
    Object.entries(group).forEach(([field, rule]) => {
      flatRules[field] = rule;
    });
  });

  // 🔹 Normalize backend fields → frontend fields
  const normalizedRules = {};
  Object.entries(flatRules).forEach(([ruleKey, rule]) => {
    const target = RULE_FIELD_MAP[ruleKey];
    if (!target) return;

    if (Array.isArray(target)) {
      target.forEach(field => {
        normalizedRules[field] = rule;
      });
    } else {
      normalizedRules[target] = rule;
    }
  });

  // 🔹 Validate fields
  Object.keys(normalizedRules).forEach(field => {
    const value = formData[field];
    const rule = normalizedRules[field];

    // Required check
    if (rule.required && (value === undefined || value === null || String(value).trim() === '')) {
      errors[field] = rule.message || `${field} is required`;
      return;
    }

    // Skip empty optional fields
    if (!value) return;

    try {
      // Regex validation
      if (rule.regex) {
        const re = new RegExp(rule.regex);
        if (!re.test(String(value).trim())) {
          errors[field] = rule.message || `${field} is invalid`;
          return;
        }
      }

      // String length validation
      if (rule.min && String(value).length < rule.min) {
        errors[field] = rule.message || `${field} must be at least ${rule.min} characters`;
      }
      if (rule.max && String(value).length > rule.max) {
        errors[field] = rule.message || `${field} must be at most ${rule.max} characters`;
      }

      // Numeric range validation
      const numericValue = Number(value);
      if (!isNaN(numericValue)) {
        if (rule.min_value !== undefined && numericValue < rule.min_value) {
          errors[field] = rule.message || `${field} must be ≥ ${rule.min_value}`;
        }
        if (rule.max_value !== undefined && numericValue > rule.max_value) {
          errors[field] = rule.message || `${field} must be ≤ ${rule.max_value}`;
        }
      }
    } catch (err) {
      errors[field] = `Invalid ${field}`;
    }
  });

  return errors;
}
